export default __webpack_public_path__ + "static/media/ShieldGreen.ff0fb411.svg";